import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setSessionStorage } from '@utils/windowUtil';
import { isEmailVerifiedOrBypassed } from '@utils/emailVerificationBypass';
import actions from '@flux/action';
import { isEmailVerifiedForUi } from '@utils/emailVerificationGate';

const ProjectSettingDirect = ({ projectId, projectName }) => {
  const location = useLocation();
  const history = useHistory();
  const emailVerModalRef = useSelector(
    (state) => state.common.emailVerModalRef,
  );
  const dispatch = useDispatch();
  const userInfo = useSelector(({ login }) => login.userInfo);

  const icon = location.pathname.includes('/projects/setting')
    ? 'icon-setting-fill'
    : 'icon-setting-outline';

  const handleSetting = () => {
    setSessionStorage('projectName', projectName);
    setSessionStorage('currentId', projectId);
    history.push(`/projects/setting?projectId=${projectId}`);
  };
  return (
    <div
      className="project-setting"
      onClick={(e) => {
        e.stopPropagation();
        if (isEmailVerifiedOrBypassed(userInfo)) {
          handleSetting();
        } else {
          emailVerModalRef &&
            emailVerModalRef.show &&
            emailVerModalRef.show({
              callback: () => {
                handleSetting();
                dispatch(actions.getUserInfo);
              },
            });
        }
      }}
    >
      <span className={`appkiticon ${icon}`} />
    </div>
  );
};

export default ProjectSettingDirect;
